import { InlineMessageVariant } from '@ingka/inline-message';
import { Dispatch } from 'react';
import { setAdjustableClothRailInformationSheet } from '../features/AdjustableClothRailFeature';
import Icon from '@ingka/ssr-icon/paths/thumbs-up';

export const getAdjustableClothRailInfoMessage = (dispatch: Dispatch<any>) => ({
  title: 'storageone.jonaxelAdjClRailInfoMessageTitle',
  body: 'storageone.jonaxelAdjClRailInfoMessageBody',
  type: 'positive' as InlineMessageVariant,
  action: {
    onClick: () => {
      dispatch(setAdjustableClothRailInformationSheet(true));
    },
    text: 'storageone.jonaxelAdjClRailInfoMessageButton'
  },
  ssrIcon: Icon
});
